import React, { useMemo, useState } from 'react';
import { UserTimeline } from '@conviva/organism-components';
import { useConnectionData } from '@src/pages/VisualActivation/store';

const Timeline = ({
  timelineData,
  title,
  onClick,
}: Pick<
  React.ComponentProps<typeof UserTimeline>,
  'timelineData' | 'summaryData' | 'idGroupData'
> & {
  title?: string;
  onClick?: (value: any) => void;
  selectEvent: any;
}) => {
  const { clearTimeline } = useConnectionData();
  const [receivingData, setReceivingData] = useState<'Receiving...' | 'Stopped'>('Receiving...');
  const [enableNetworkRequest, setEnableNetworkRequest] = useState(true);

  const [autoScroll, setAutoScroll] = useState(true);
  const [eventFilterOn, setEventFilterOn] = useState(false);

  const data = useMemo(() => {
    if (enableNetworkRequest) {
      return timelineData;
    } else {
      return timelineData.filter((item) => {
        return item.eventName !== 'conviva_network_request';
      });
    }
  }, [timelineData, enableNetworkRequest]);

  return (
    <UserTimeline
      timelineData={data}
      enableShowSummary={false}
      timelineTitle={<span>{title}</span>}
      showClearBtn={true}
      showAutoScrollBtn={true}
      autoScroll={autoScroll}
      dataStatus={receivingData}
      eventFilterOn={eventFilterOn}
      onClickEvent={onClick}
      onEventFilterOnChange={(value) => {
        setEventFilterOn(value);
      }}
      enableNetworkRequest={enableNetworkRequest}
      onNetworkRequestToggleChange={() => {
        setEnableNetworkRequest(!enableNetworkRequest);
      }}
      clearTimeline={() => {
        clearTimeline();
      }}
    />
  );
};

export default React.memo(Timeline);
